import React, { useState } from 'react';
import {
  Collapse, Typography, Box, makeStyles,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import Typography500 from 'common/components/Typography500';
import { Alert, AlertTitle } from '@material-ui/lab';

import { withTranslation } from 'next-i18next';

const useStyles = makeStyles((theme) => ({
  widgetAlert: {
    '& .MuiAlert-root': {
      borderRadius: '0',
      color: theme.palette.grey[900],
    },
    '& ul': {
      paddingLeft: theme.spacing(1.5),
      margin: '0',
    },
  },
}));

const WidgetWarning = (props) => {
  const { t, alertMessage } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  return (
    <Box className={classes.widgetAlert} mb={2}>
      <Collapse in={open}>
        <Alert
          severity="warning"
          onClose={() => {
            setOpen(false);
          }}
          variant="filled"
          icon={<WarningIcon fontSize="small" />}
        >
          <AlertTitle>
            <Typography500 variant="body2" component="p">
              {t('fe_es_common_main_widget:warning')}
            </Typography500>
          </AlertTitle>
          <ul>
            {alertMessage.map((item) => (
              <li>
                <Typography variant="body2" component="p">
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </Alert>
      </Collapse>
    </Box>
  );
};
export default withTranslation('fe_es_common_main_widget')(WidgetWarning);
